<template>
  <card>
    <list
      :params="params"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="false"
      :itemLink="itemLink"
      :filters="filters"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :setImport="true"
      :exportFields="exportFields"
    />
  </card>
</template>
  <script>
export default {
  name: "groups",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        Класс: "title",
        Рейтинг: "average_rating",
      },
      params: {},
      val: [],
      modalCreate: "group",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "item_group",
      itemLink: "business/rating/groups",
      setLink: "business/rating/groups",
      columns: [
        {
          key: "title",
          title: "Класс",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "average_rating",
          title: "Рейтинг",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
      ],
      filters: [
        {
          key: "season",
          title: "Учебный сезон",
        },
        {
          key: "course",
          title: "Номер класса",
        },
      ],
    };
  },
};
</script>
  <style>
</style>
  